<template>
	<div>

		<AssessmentNavigation></AssessmentNavigation>

		<NavigationGroup 
			name="Ergebnisse" 
			icon="mdi-chart-line" 
			iconcolor="grey"
			description="Auswertungsmodule Ihrer Reifegraderhebung"
			tooltip="false"
			type="collapse"
			:children="[
			{name: 'Dashboard', type: 'link', to: 'results', icon: 'mdi-target', description: 'Ihre zusammengefassten Erhebungsergebnisse' },
			{name: 'Detailansicht', type: 'link', to: 'analyse', icon: 'mdi-chart-multiple', description: 'Ihre gesamten Erhebungsergebnisse' },
			]"
			>
			
		</NavigationGroup>
		<div class="mt-5 text-center">
			<ScoreAvatar level="total"></ScoreAvatar>
		</div>
		
	</div>
</template>

<script>

	import Vuex from "vuex"
	import ScoreAvatar from "@/components/assessment/content/ScoreAvatar"

	// import NavigationItem from "@/components/elements/NavigationItem"
	import NavigationGroup from "@/components/elements/NavigationGroup"
	import AssessmentNavigation from "@/components/assessment/content/AssessmentNavigation"
	export default {
		name: "UserNav", 
		computed: {
			...Vuex.mapState({
				user: state => state.user
			}),
		},
		data: () => {
			return {

			}
		}, 
		components: {
			// NavigationItem, 
			ScoreAvatar,
			NavigationGroup, 
			AssessmentNavigation
		},
		methods: {
		}
	}
</script>